export const INITIAL_STATE = {
  mobileTLInputs: {
    operator: '',
    vodafone: {
      gsmNumber: '',
      productId: '',
      saveInput: false,
      isSavedPhone: true,
      currentSavedNumber: {
        id: '',
        gsmNumber: '',
      },
    },
    turk_telekom: {
      gsmNumber: '',
      productId: '',
      saveInput: false,
      isSavedPhone: true,
      currentSavedNumber: {
        id: '',
        gsmNumber: '',
      },
    },
  },
  mobilePackageInputs: {
    operator: '',
    vodafone: {
      gsmNumber: '',
      productId: '',
      saveInput: false,
      isSavedPhone: true,
      currentSavedNumber: {
        id: '',
        gsmNumber: '',
      },
    },
    turk_telekom: {
      gsmNumber: '',
      productId: '',
      saveInput: false,
      isSavedPhone: true,
      currentSavedNumber: {
        id: '',
        gsmNumber: '',
      },
    },
  },
  referenceId: '',
  walletGiftCodeInputs: {
    sendMethod: '',
    email: '',
    gsmNumber: '',
    sender: '',
    productId: '',
    amount: '',
    isScheduled: false,
    scheduleDate: '',
    scheduleTime: '',
    imageUrl: '',
    templateOrPhotoSelection: '',
  },
  raffleLandingModalViewsIncreased: false,
  preOrderId: '',
};

export const ACTION_TYPES = {
  DEFAULT: 'DEFAULT',
  ADD_MOBILE_TL_INPUTS: 'ADD_MOBILE_TL_INPUTS',
  ADD_MOBILE_PACKAGE_INPUTS: 'ADD_MOBILE_PACKAGE_INPUTS',
  CLEAR_MOBILE_TL_INPUTS: 'CLEAR_MOBILE_TL_INPUTS',
  CLEAR_MOBILE_PACKAGE_INPUTS: 'CLEAR_MOBILE_PACKAGE_INPUTS',
  ADD_PRODUCT_ID: 'ADD_PRODUCT_ID',
  ADD_REFERENCE_ID: 'ADD_REFERENCE_ID',
  ADD_WALLET_GIFT_CODE_INPUTS: 'ADD_WALLET_GIFT_CODE_INPUTS',
  SET_RAFFLE_LANDING_MODAL_VIEWS_INCREASED:
    'SET_RAFFLE_LANDING_MODAL_VIEWS_INCREASED',
  ADD_PREORDER_ID: 'ADD_PREORDER_ID',
} as const;
